<script setup name="PortsNumber">
defineProps({
  number: {
    type: [Number, String],
    required: true,
  },
});
</script>

<template>
  <div
    class="flex h-6 w-6 items-center justify-center rounded-full border-3 border-solid border-secondary-3 bg-white text-xs font-black text-secondary-3"
    style="z-index: 1"
  >
    {{ number }}
  </div>
</template>
